// Thin WebSocket client with reconnect. Messages are JSON; the server may send arrays.
import { ClientMsg, ServerMsg, PROTOCOL } from './protocol';

export const API_BASE: string = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
export const apiUrl = (path: string) => `${API_BASE}${path}`;
export const wsUrl = (city: string, room = '', label = '') => { const q = new URLSearchParams(); if (room) q.set('room', room); if (label) q.set('label', label); const s = q.toString(); return `${(API_BASE || location.origin).replace(/^http/, 'ws')}/ws/${encodeURIComponent(city)}${s ? '?' + s : ''}`; };

export class Client {
  ws: WebSocket | null = null; open = false; closedByUs = false; retries = 0; timer: any = null;
  constructor(public url: string, public hello: { pid: string; name: string }, public onMsg: (m: ServerMsg) => void, public onState: (open: boolean) => void) {}
  connect() {
    this.closedByUs = false;
    let ws: WebSocket; try { ws = new WebSocket(this.url); } catch (e) { this.scheduleRetry(); return; }
    this.ws = ws;
    ws.onopen = () => { this.open = true; this.retries = 0; this.raw({ t: 'hello', v: PROTOCOL, pid: this.hello.pid, name: this.hello.name }); this.onState(true); };
    ws.onmessage = ev => { let m: any; try { m = JSON.parse(ev.data); } catch (e) { return; } for (const x of Array.isArray(m) ? m : [m]) this.onMsg(x); };
    ws.onclose = () => { const was = this.open; this.open = false; if (was) this.onState(false); if (!this.closedByUs) this.scheduleRetry(); };
    ws.onerror = () => {};
  }
  scheduleRetry() { if (this.closedByUs || this.retries >= 6) return; const d = Math.min(8000, 800 * 2 ** this.retries++); this.timer = setTimeout(() => this.connect(), d); }
  raw(m: ClientMsg) { if (this.open && this.ws) { try { this.ws.send(JSON.stringify(m)); } catch (e) {} } }
  send(m: ClientMsg) { this.raw(m); }
  close() { this.closedByUs = true; clearTimeout(this.timer); this.open = false; try { this.ws?.close(1000); } catch (e) {} this.ws = null; }
}
export function playerId(): string {
  try { let id = localStorage.getItem('polarize.pid'); if (!id) { id = crypto.randomUUID(); localStorage.setItem('polarize.pid', id); } return id; } catch (e) { return 'anon-' + Math.random().toString(36).slice(2, 10); }
}
